module.exports = __webpack_public_path__ + "static/media/PublicBgBottom.5019770a.svg";